import React from "react";

// eslint-disable-next-line no-restricted-imports
import { WizardStepper, WizardStepperStep } from "@packages/ds";
import { useNavigate } from "react-router-dom";

/**
 * Extended step type with path for routing
 */
interface RoutableWizardStep extends WizardStepperStep {
  /** Path to navigate to when step is clicked */
  stepPath?: string;
}

interface Props {
  steps: Array<RoutableWizardStep>;
  hasLabel: boolean;
}

/**
 * Router-aware WizardStepperWrapper that integrates with react-router
 */
const WizardStepperWrapper = ({ steps, hasLabel }: Props) => {
  const navigate = useNavigate();

  const handleStepClick = (step: RoutableWizardStep) => {
    if (step.stepPath) {
      navigate(step.stepPath);
    }
  };

  return (
    <WizardStepper.StepperWrapper
      steps={steps}
      hasLabel={hasLabel}
      onStepClick={handleStepClick}
    />
  );
};

export default WizardStepperWrapper;
